import { Subject } from 'rxjs';

export abstract class ActionComponent {
  action: any = {};
  mission: any = {};
  subject: Subject<any> = new Subject<any>();
}
